module.exports = __webpack_public_path__ + "static/3A841E_1_0-760a9871c0c18db1dc29dad3f5c0c62f.woff2";